import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';

const youtubeMap: Record<string, string> = {
    eu: 'https://www.youtube.com/embed/V2dsDTVphHA',
    de: 'https://www.youtube.com/embed/D0UCWIppajY',
    fr: 'https://www.youtube.com/embed/-aTgVa3UGEA',
    it: 'https://www.youtube.com/embed/-Fby_6FywQo',
    es: 'https://www.youtube.com/embed/68pU4hcpgkI',
};

export default function Comp() {
    const { t } = useLang('theProduct.BannerB2');
    const { locale } = getLocal();
    const youtubeHref = youtubeMap[locale] || youtubeMap.eu;

    const dataB: EcoBannerProps = {
        layout: 'top-center',
        theme: 'white',
        pc:
            locale === 'uk'
                ? 'https://websiteoss.ecoflow.com/upload/image/1762136854893/ac-kv-uk.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1745587269967/ac-kv.jpg',
        h5:
            locale === 'uk'
                ? 'https://websiteoss.ecoflow.com/upload/image/1762136903472/ac-kv-m-uk.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1745587362007/ac-m-kv.jpg',
        // label: t('label'),
        labelColor: '#000',
        title: t('title'),
        subTitle: t('desc'),
        subTitleColor: '#000',
        titleColor: '#000',
        desc: t('desc2'),
        descColor: '#FAA10E',
        lChildren: t('btn1'),
        lType: 'outlined',
        lRadius: 'ellipse',
        lBtnIsYouToBe: true,
        lHref: youtubeHref,
    };
    return (
        <div className={styled.banner}>
            <EcoBanner theme="black" {...dataB} />
        </div>
    );
}
